import { get, toLower } from 'lodash'
const { PARTNER_REGISTER_OVERRIDE } = process.env

function isPartnerRegisterEnabled(communityConfig) {
  return (
    get(communityConfig, 'partnerRegisterEnabled') ||
    toLower(PARTNER_REGISTER_OVERRIDE) === 'true'
  )
}

export default isPartnerRegisterEnabled
